import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../utils';
import constant from '../../constant';

const Configure = ({ onSubmit, data, onLogout, onMicrosoftSSO, onCancel, submitLabel = 'Submit', submitDisabled = false }) => {
    const [state, setState] = useState({
        email: { name: 'email', value: '', isRequired: true, error: '' },
        password: { name: 'password', value: '', isRequired: true, error: '' },
        host: { name: 'host', value: '', isRequired: true, error: '' },
        imap_host: { name: 'imap_host', value: '', isRequired: false, error: '' },
        imap_port: { name: 'imap_port', value: '', isRequired: false, error: '' },
        imap_tls: { name: 'imap_tls', value: '', isRequired: false, error: '' },
        smtp_host: { name: 'smtp_host', value: '', isRequired: false, error: '' },
        smtp_port: { name: 'smtp_port', value: '', isRequired: false, error: '' },
        smtp_secure: { name: 'smtp_secure', value: '', isRequired: false, error: '' },
    });
    const selectedHost = data?.HOST || state.host.value;
    const isMicrosoft = selectedHost === 'microsoft';
    const isLegacyMicrosoft = ['outlook', 'hotmail'].includes(selectedHost);
    const isOtherHost = selectedHost === 'other';

    useEffect(() => {
        setState(prev => {
            const updated = { ...prev };
            const fieldsToUpdate = ['imap_host', 'imap_port', 'imap_tls', 'smtp_host', 'smtp_port', 'smtp_secure'];
            fieldsToUpdate.forEach(field => {
                updated[field].isRequired = isOtherHost;
            });
            return updated;
        });
    }, [isOtherHost]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState(prev => {
            const updatedState = {
                ...prev,
                [name]: {
                    ...prev[name],
                    value,
                    error: prev[name].isRequired && !value ? 'This field is required' : ''
                }
            };
            return updatedState;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            onSubmit(model);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Host</label>
                    <select
                        name="host"
                        value={data?.HOST || state.host.value}
                        onChange={data ? () => { } : handleChange}
                        disabled={!!data}
                        className={`form-control ${state.host.error ? 'is-invalid' : ''}`}
                    >
                        <option value="">Select Host</option>
                        <option value="gmail">Gmail</option>
                        <option value="yahoo">Yahoo</option>
                        <option value="microsoft">Microsoft 365 / Outlook (SSO)</option>
                        {isLegacyMicrosoft && (
                            <option value={selectedHost}>Microsoft password login (unsupported)</option>
                        )}
                        <option value="other">Other</option>
                    </select>
                    {state.host.error && <div className="invalid-feedback">{state.host.error}</div>}
                </div>

                {/* MICROSOFT SSO */}
                {isMicrosoft && (
                    <div className="col-md-12 mt-3">
                        <div className="alert alert-info">
                            Microsoft email requires secure login via Azure SSO.
                        </div>

                        {!data ? (
                            <button
                                type="button"
                                className="btn btn-success me-2"
                                onClick={() => {
                                    onMicrosoftSSO()
                                }}
                            >
                                Choose Microsoft Account
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={onLogout}
                            >
                                Logout Microsoft Account
                            </button>
                        )}
                    </div>
                )}


                {/* NON-MICROSOFT */}
                {!isMicrosoft && (
                    <>
                        <div className="col-md-6 mb-3">
                            <label>Email</label>
                            <input
                                name="email"
                                value={data?.EMAIL || state.email.value}
                                disabled={!!data}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={data?.PASSWORD || state.password.value}
                                disabled={!!data}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                    </>
                )}

                {isLegacyMicrosoft && (
                    <div className="col-md-12">
                        <div className="alert alert-warning">
                            Microsoft has disabled password-based IMAP login for this mailbox. Remove it and add it again using Microsoft 365 / Outlook (SSO).
                        </div>
                    </div>
                )}

                {isOtherHost && (
                    <>
                        <div className="col-md-6 mb-3">
                            <label>IMAP Host</label>
                            <input
                                placeholder='Enter IMAP Host'
                                name="imap_host"
                                value={data?.IMAP_HOST || state.imap_host.value}
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-control ${state.imap_host.error ? 'is-invalid' : ''}`}
                            />
                            {state.imap_host.error && <div className="invalid-feedback">{state.imap_host.error}</div>}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>IMAP Port</label>
                            <input
                                name="imap_port"
                                placeholder='Enter IMAP Port'

                                value={data?.IMAP_PORT || state.imap_port.value}
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-control ${state.imap_port.error ? 'is-invalid' : ''}`}
                            />
                            {state.imap_port.error && <div className="invalid-feedback">{state.imap_port.error}</div>}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>IMAP TLS</label>
                            <select
                                name="imap_tls"
                                value={data ? data?.IMAP_TLS == 1 ? 'true' : 'false' : state.imap_tls.value}
                                placeholder='Enter IMAP TLS'
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-select ${state.imap_tls.error ? 'is-invalid' : ''}`}
                            >
                                <option value={''}>Select</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                            </select>
                            {state.imap_tls.error && <div className="invalid-feedback">{state.imap_tls.error}</div>}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>SMTP Host</label>
                            <input
                                name="smtp_host"
                                placeholder='Enter SMTP Host'

                                value={data?.SMTP_HOST || state.smtp_host.value}
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-control ${state.smtp_host.error ? 'is-invalid' : ''}`}
                            />
                            {state.smtp_host.error && <div className="invalid-feedback">{state.smtp_host.error}</div>}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>SMTP Port</label>
                            <input
                                name="smtp_port"
                                placeholder='Enter SMTP Port'

                                value={data?.SMTP_PORT || state.smtp_port.value}
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-control ${state.smtp_port.error ? 'is-invalid' : ''}`}
                            />
                            {state.smtp_port.error && <div className="invalid-feedback">{state.smtp_port.error}</div>}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>SMTP Connection Security</label>
                            <select
                                name="smtp_secure"
                                value={data ? data?.SMTP_SECURE == 1 ? 'true' : 'false' : state.smtp_secure.value}
                                disabled={!!data}
                                onChange={data ? () => { } : handleChange}
                                className={`form-select ${state.smtp_secure.error ? 'is-invalid' : ''}`}
                            >
                                <option value={''}>Select</option>
                                <option value={true}>Implicit SSL/TLS</option>
                                <option value={false}>STARTTLS</option>

                            </select>
                            {state.smtp_secure.error && <div className="invalid-feedback">{state.smtp_secure.error}</div>}
                        </div>
                    </>
                )}
            </div>

            {!isMicrosoft && (
                <div className="my-3">
                    {data ? (
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={onLogout}
                        >
                            {isLegacyMicrosoft ? 'Remove mailbox' : 'Logout'}
                        </button>
                    ) : (
                        <>
                            <button type="submit" className="btn btn-success me-2" disabled={submitDisabled}>
                                {submitLabel}
                            </button>
                            {onCancel ? <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button> :
                                <a className="btn btn-secondary" href={constant.Authedcomponent.dashboard.url}>Cancel</a>}
                        </>
                    )}
                </div>
            )}
        </form>
    );
};

export default Configure;
